import { Component } from '@angular/core';

@Component({
  selector: 'app-view-add-parent',
  templateUrl: './view-add-parent.component.html',
  standalone: false,
})
export class ViewAddParentComponent {
  title: string = 'Agregar categoría padre';
  loadParentId: boolean = false;

  constructor() {
    //this is a constructor
  }
}
